var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { activeCellChanged, beginAction, getCell, getCellAddress, getCellIndexes, getSortedIndex, getRowHeight, getSheetName, importModelUpdate, setCell } from '../../workbook/index';
import { initiateComment, completeAction, createCommentIndicator, deleteComment, removeCommentContainer, locale, replyToComment, showCommentsPane, refreshCommentsPane, commentUndoRedo, getDPRValue, processSheetComments } from '../index';
import { Browser, closest, detach, enableRipple, EventHandler, getComponent, getUniqueID, isNullOrUndefined } from '@syncfusion/ej2-base';
import { getUpdateUsingRaf, navigateNextPrevComment, updateNoteContainer, destroyComponent } from './../common/index';
import { getRangeAddress, updateCell, getISOTime } from '../../workbook/index';
import { Button } from '@syncfusion/ej2-buttons';
import { DropDownButton } from '@syncfusion/ej2-splitbuttons';
import { ListView, Virtualization } from '@syncfusion/ej2-lists';
ListView.Inject(Virtualization);
/**
 * Comment module.
 */
var SpreadsheetComment = /** @class */ (function () {
    /**
     * Initializes a new instance of the `SpreadsheetComment` class
     *
     * @param {Spreadsheet} parent - Constructor for SpreadsheetComment module.
     */
    function SpreadsheetComment(parent) {
        /** @hidden */
        this.isCommentVisible = false;
        /** @hidden */
        this.isCommentVisibleOnTouch = false;
        /** @hidden */
        this.isReviewPaneVisible = false;
        this.isEditing = false;
        this.reviewInstances = [];
        this.reviewFilter = 'all';
        this.scheduleMountId = 0;
        this.parent = parent;
        this.addEventListener();
    }
    SpreadsheetComment.prototype.addEventListener = function () {
        this.parent.on(initiateComment, this.initiateComment, this);
        this.parent.on(deleteComment, this.deleteComment, this);
        this.parent.on(createCommentIndicator, this.createCommentIndicator, this);
        this.parent.on(removeCommentContainer, this.removeCommentContainer, this);
        this.parent.on(replyToComment, this.replyToComment, this);
        this.parent.on(importModelUpdate, this.updateCommentsFromSheet, this);
        this.parent.on(showCommentsPane, this.showCommentPane, this);
        this.parent.on(navigateNextPrevComment, this.navigateNextPrevComment, this);
        this.parent.on(refreshCommentsPane, this.refreshCommentsPane, this);
        this.parent.on(processSheetComments, this.processSheetComments, this);
        this.parent.on(commentUndoRedo, this.onCommentUndoRedo, this);
        this.parent.on(activeCellChanged, this.commentHandler, this);
    };
    SpreadsheetComment.prototype.removeEventListener = function () {
        if (!this.parent.isDestroyed) {
            this.parent.off(initiateComment, this.initiateComment);
            this.parent.off(deleteComment, this.deleteComment);
            this.parent.off(createCommentIndicator, this.createCommentIndicator);
            this.parent.off(removeCommentContainer, this.removeCommentContainer);
            this.parent.off(replyToComment, this.replyToComment);
            this.parent.off(importModelUpdate, this.updateCommentsFromSheet);
            this.parent.off(showCommentsPane, this.showCommentPane);
            this.parent.off(navigateNextPrevComment, this.navigateNextPrevComment);
            this.parent.off(refreshCommentsPane, this.refreshCommentsPane);
            this.parent.off(processSheetComments, this.processSheetComments);
            this.parent.off(commentUndoRedo, this.onCommentUndoRedo);
            this.parent.off(activeCellChanged, this.commentHandler);
        }
    };
    SpreadsheetComment.prototype.initiateComment = function (args) {
        var cellIndexes = (args && !isNullOrUndefined(args.rowIndex) && !isNullOrUndefined(args.columnIndex)) ?
            [args.rowIndex, args.columnIndex] : getCellIndexes(this.parent.getActiveSheet().activeCell);
        var targetElement = this.parent.getCell(cellIndexes[0], cellIndexes[1]);
        if (!isNullOrUndefined(targetElement)) {
            if (!targetElement.querySelector('.e-comment-indicator')) {
                this.createCommentIndicator({ targetEle: targetElement, rIdx: cellIndexes[0], cIdx: cellIndexes[1] });
            }
            if (args && args.isMouseOver) {
                this.createCommentContainer(targetElement, cellIndexes[0], cellIndexes[1]);
                this.activeCommentCell = [cellIndexes[0], cellIndexes[1]];
                return;
            }
            if (this.isReviewPaneVisible) {
                var sheet = this.parent.getActiveSheet();
                var existing = (sheet.comments || []).find(function (t) { return t.address && t.address[0] === cellIndexes[0] && t.address[1] === cellIndexes[1]; });
                if (existing && existing.id) {
                    this.scrollToThreadInPanel(existing.id, args && args.isSelection);
                }
                else {
                    this.renderNewCommentForPanel(cellIndexes[0], cellIndexes[1]);
                }
            }
            else {
                this.createCommentContainer(targetElement, cellIndexes[0], cellIndexes[1]);
                this.activeCommentCell = [cellIndexes[0], cellIndexes[1]];
            }
        }
    };
    SpreadsheetComment.prototype.createCommentIndicator = function (args) {
        var commentIndicator = this.parent.createElement('div', { className: 'e-comment-indicator' });
        if (args.targetEle.children.length > 0) {
            var rowHeight = getRowHeight(this.parent.getActiveSheet(), args.rIdx);
            var defaultFilterButtonHeight = 20;
            for (var i = 0; i < args.targetEle.childElementCount; i++) {
                var children = args.targetEle.children[i];
                if (children.className.indexOf('e-filter-btn') > -1) {
                    if (this.parent.enableRtl) {
                        commentIndicator.style.left = (rowHeight < (defaultFilterButtonHeight + 10) ?
                            (children.getBoundingClientRect().width <= 0 ? defaultFilterButtonHeight :
                                children.getBoundingClientRect().width + 1) : 2) + 'px';
                    }
                    else {
                        commentIndicator.style.right = (rowHeight < (defaultFilterButtonHeight + 10) ?
                            (children.getBoundingClientRect().width <= 0 ? defaultFilterButtonHeight :
                                children.getBoundingClientRect().width + 1) : 2) + 'px';
                    }
                }
                if (children.className.indexOf('e-validation-list') > -1) {
                    if (this.parent.enableRtl) {
                        commentIndicator.style.left = (children.getBoundingClientRect().width || 20) + 2 + "px";
                    }
                    else {
                        commentIndicator.style.right = (children.getBoundingClientRect().width || 20) + 2 + "px";
                    }
                }
            }
        }
        if (!commentIndicator.dataset.commentListenersAdded && !args.skipEvent) {
            commentIndicator.dataset.commentRowIndex = args.rIdx.toString();
            commentIndicator.dataset.commentColIndex = args.cIdx.toString();
            EventHandler.add(commentIndicator, 'mouseover', this.mouseOver, this);
            EventHandler.add(commentIndicator, 'mouseout', this.mouseOut, this);
            commentIndicator.dataset.commentListenersAdded = 'true';
        }
        args.targetEle.appendChild(commentIndicator);
    };
    SpreadsheetComment.prototype.mouseOver = function (event) {
        var cell = event.currentTarget;
        var row = parseInt(cell.dataset.commentRowIndex, 10);
        var col = parseInt(cell.dataset.commentColIndex, 10);
        if (!isNaN(row) && !isNaN(col)) {
            var containerInDOM = document.getElementsByClassName('e-comment-container')[0];
            if ((this.isCommentVisibleOnTouch && !isNullOrUndefined(containerInDOM)) || isNullOrUndefined(containerInDOM)) {
                if (!isNullOrUndefined(containerInDOM)) {
                    this.removeCommentContainer();
                }
                this.initiateComment({ rowIndex: row, columnIndex: col, isMouseOver: true });
                this.isCommentVisible = true;
            }
        }
    };
    SpreadsheetComment.prototype.mouseOut = function (e) {
        var commentContainer = this.getCommentContainer();
        var relatedTarget = e.relatedTarget;
        if (this.isCommentVisible && (!this.isCommentVisibleOnTouch && commentContainer)) {
            if (relatedTarget) {
                var isInsideContainer = commentContainer.contains(relatedTarget);
                var isInsideIndicator = closest(relatedTarget, '.e-comment-indicator');
                var isInsideDropDownPopup = closest(relatedTarget, '.e-dropdown-popup');
                var isCommentCell = this.parent.getCell(this.activeCommentCell[0], this.activeCommentCell[1]);
                if (!isInsideContainer && !isInsideIndicator && !isInsideDropDownPopup &&
                    isCommentCell && !isCommentCell.contains(relatedTarget) &&
                    document.activeElement !== commentContainer &&
                    document.activeElement !== commentContainer.querySelector('.e-comment-input')) {
                    this.removeCommentContainer();
                    this.isCommentVisible = false;
                    this.activeCommentCell = null;
                }
            }
        }
    };
    SpreadsheetComment.prototype.createCommentContainer = function (targetEle, rIdx, cIdx) {
        var commentContainer = this.parent.createElement('div', { className: 'e-comment-container' });
        commentContainer.tabIndex = -1;
        this.renderCommentUI(commentContainer, rIdx, cIdx, false);
        commentContainer.style.visibility = 'hidden';
        this.parent.element.appendChild(commentContainer);
        this.setCommentContainerPosition(commentContainer, targetEle.getBoundingClientRect());
        commentContainer.style.visibility = '';
        var cell = getCell(rIdx, cIdx, this.parent.getActiveSheet());
        var thread = cell && cell.comment;
        if (thread && thread.isResolved) {
            this.handleResolvedThread(commentContainer, rIdx, cIdx, thread);
        }
        var textArea = commentContainer.querySelector('.e-comment-footer .e-comment-input');
        if (textArea && (!cell || (cell && !cell.comment))) {
            textArea.focus();
            textArea.select();
            if (!commentContainer.classList.contains('active')) {
                commentContainer.classList.add('active');
            }
        }
        this.bindContainerEvents(commentContainer);
        EventHandler.add(commentContainer, 'mouseout', this.mouseOut, this);
        EventHandler.add(targetEle, 'mouseout', this.mouseOut, this);
        this.isCommentVisible = true;
    };
    SpreadsheetComment.prototype.handleResolvedThread = function (container, rIdx, cIdx, thread) {
        var headerEl = container.querySelector('.e-comment-header');
        if (headerEl) {
            headerEl.replaceWith(this.createheaderContent(false, getCellAddress(rIdx, cIdx), thread));
        }
        var footerEl = container.querySelector('.e-comment-footer');
        if (footerEl) {
            this.unwireFooterEvents(footerEl);
            this.removeFooterButtons(footerEl);
            footerEl.remove();
        }
        container.classList.add('e-thread-resolved');
        this.removeReplyButtons(container.querySelector('.e-comment-body'));
        this.setTextAreaState(container, true);
        this.renderResolvedWrap(container, rIdx, cIdx, thread.author || (this.parent.author || 'Guest User'));
    };
    SpreadsheetComment.prototype.renderCommentUI = function (container, rIdx, cIdx, inPane, containerId) {
        var sheet = this.parent.getActiveSheet();
        var cell = getCell(rIdx, cIdx, sheet);
        var header;
        var body;
        var footer;
        if (cell && cell.comment) {
            var cellAddress = getCellAddress(rIdx, cIdx);
            header = this.createheaderContent(false, cellAddress, cell.comment);
            body = this.createBodyContent(cell.comment, true, inPane, containerId);
            footer = this.createFooterContent(rIdx, cIdx, false);
        }
        else {
            header = this.createheaderContent(true);
            footer = this.createFooterContent(rIdx, cIdx, true);
        }
        if (!inPane) {
            container.dataset.commentRowIndex = rIdx.toString();
            container.dataset.commentColIndex = cIdx.toString();
        }
        container.appendChild(header);
        if (body) {
            container.appendChild(body);
        }
        container.appendChild(footer);
    };
    SpreadsheetComment.prototype.createheaderContent = function (initial, cellAddress, comment) {
        var header = this.parent.createElement('div', { className: 'e-comment-header' });
        var headerwrap = this.parent.createElement('div', { className: 'e-comment-header-wrap' });
        var titleWrap = this.parent.createElement('div', { className: 'e-comment-title-wrap' });
        var thread = comment;
        if (!initial && thread && thread.isResolved) {
            var l10n = this.parent.serviceLocator.getService(locale);
            var resolvedWrap = this.parent.createElement('div', { className: 'e-comment-resolved' });
            var tick = this.parent.createElement('span', { className: 'e-icons e-check' });
            var label = this.parent.createElement('div', { className: 'e-resolve-text' });
            label.textContent = l10n.getConstant('Resolved');
            resolvedWrap.appendChild(tick);
            resolvedWrap.appendChild(label);
            headerwrap.appendChild(resolvedWrap);
            this.renderHeaderActions(headerwrap, false, '', thread);
            header.appendChild(headerwrap);
            return header;
        }
        var authorName = initial ? (this.parent.author || 'Guest User') : (thread && thread.author);
        var avatar = this.getAvatar(authorName);
        var title = this.parent.createElement('div', { className: 'e-comment-title' });
        title.textContent = authorName;
        titleWrap.appendChild(title);
        headerwrap.appendChild(titleWrap);
        this.renderHeaderActions(headerwrap, initial, cellAddress, thread);
        header.appendChild(avatar);
        header.appendChild(headerwrap);
        return header;
    };
    SpreadsheetComment.prototype.getAvatar = function (author) {
        var avatar = this.parent.createElement('div', { className: 'e-comment-avatar' });
        avatar.textContent = this.getAvatarInitials(author);
        var currentUser = this.parent.author || 'Guest User';
        if (author === currentUser) {
            avatar.style.backgroundColor = '#b5082e';
        }
        else {
            avatar.style.backgroundColor = this.getAuthorColor(author);
        }
        return avatar;
    };
    SpreadsheetComment.prototype.getAuthorColor = function (author) {
        var colors = ['#b5082e', '#2e97d3', '#bb00ff', '#f37e43', '#03a60b', '#881824', '#e09a2b', '#50565e', '#1f7a8c',
            '#7b5ea7', '#2db36c', '#d9480f', '#0a58ca', '#a83279', '#00897b'];
        var authorStr = (author ? author : 'Guest User').trim().toLowerCase();
        var hash = 5381;
        for (var i = 0; i < authorStr.length; i++) {
            var code = authorStr.charCodeAt(i);
            hash = (hash * 33 + code) % 4294967296;
        }
        var idx = Math.abs(hash) % colors.length;
        return colors[idx];
    };
    SpreadsheetComment.prototype.getAvatarInitials = function (name) {
        var parts = (name ? name : 'Guest User').trim().split(' ');
        if (parts && parts.length === 1) {
            return parts[0].charAt(0).toUpperCase();
        }
        return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    };
    SpreadsheetComment.prototype.renderHeaderActions = function (headerWrap, initial, address, thread) {
        var _this = this;
        var l10n = this.parent.serviceLocator.getService(locale);
        var parentHeader = headerWrap.closest('.e-comment-header');
        var existingActions = headerWrap.querySelector('.e-comment-actions');
        if (existingActions) {
            existingActions.remove();
        }
        if (initial) {
            if (parentHeader) {
                var existingCloseBtn = parentHeader.querySelector('.e-comment-cancel');
                if (existingCloseBtn) {
                    existingCloseBtn.remove();
                }
            }
            var cancelBtn_1 = this.parent.createElement('button', {
                className: 'e-comment-cancel',
                attrs: { 'aria-label': 'Cancel', title: l10n.getConstant('Cancel') }
            });
            var button = new Button({ cssClass: 'e-flat', iconCss: 'e-icons e-close' }, cancelBtn_1);
            button.createElement = this.parent.createElement;
            EventHandler.add(button.element, 'click', function () { return _this.handleInitialCancel(cancelBtn_1); }, this);
            headerWrap.appendChild(cancelBtn_1);
            return;
        }
        if (parentHeader) {
            var existingCloseBtn = parentHeader.querySelector('.e-comment-cancel');
            if (existingCloseBtn) {
                existingCloseBtn.remove();
            }
        }
        var actionsWrap = this.parent.createElement('div', { className: 'e-comment-actions' });
        if (this.isEditing) {
            headerWrap.appendChild(actionsWrap);
            return;
        }
        if (thread && thread.isResolved === true) {
            var reopenBtnEl_1 = this.parent.createElement('button', {
                className: 'e-comment-reopen-btn',
                attrs: { type: 'button', title: l10n.getConstant('Reopen') }
            });
            var reopenBtn = new Button({ cssClass: 'e-flat', iconCss: 'e-icons e-undo' }, reopenBtnEl_1);
            reopenBtn.createElement = this.parent.createElement;
            EventHandler.add(reopenBtn.element, 'click', function () { return _this.setThreadResolved(false, reopenBtnEl_1); }, this);
            var deleteBtnEl_1 = this.parent.createElement('button', {
                className: 'e-comment-delete',
                attrs: { type: 'button', title: l10n.getConstant('DeleteThread') }
            });
            var deleteBtn = new Button({ cssClass: 'e-flat', iconCss: 'e-icons e-trash' }, deleteBtnEl_1);
            deleteBtn.createElement = this.parent.createElement;
            EventHandler.add(deleteBtn.element, 'click', function () { return _this.deleteComment({ sourceEl: deleteBtnEl_1 }); }, this);
            actionsWrap.appendChild(reopenBtnEl_1);
            actionsWrap.appendChild(deleteBtnEl_1);
            headerWrap.appendChild(actionsWrap);
            return;
        }
        var cellRef = this.parent.createElement('span', { className: 'e-comment-cellref' });
        cellRef.textContent = address;
        actionsWrap.appendChild(cellRef);
        var menuBar = this.parent.createElement('button', {
            className: 'e-comment-menu e-flat', attrs: { type: 'button', title: l10n.getConstant('ThreadAction') }
        });
        var userOption = [
            { text: l10n.getConstant('EditComment'), iconCss: 'e-icons e-edit' },
            { text: l10n.getConstant('ResolveThread'), iconCss: 'e-icons e-check' },
            { text: l10n.getConstant('DeleteThread'), iconCss: 'e-icons e-trash' }
        ];
        var menuItem = new DropDownButton({
            items: userOption,
            createPopupOnClick: true,
            iconCss: 'e-icons e-more-horizontal-1',
            cssClass: 'e-caret-hide e-menu-popup',
            enableRtl: this.parent.enableRtl,
            select: function (e) { return _this.onThreadMenuSelect(e, menuBar); },
            open: function () { return _this.setPopupPosition(menuItem, menuBar); }
        });
        menuItem.createElement = this.parent.createElement;
        menuItem.appendTo(menuBar);
        actionsWrap.appendChild(menuBar);
        headerWrap.appendChild(actionsWrap);
    };
    SpreadsheetComment.prototype.setPopupPosition = function (ddb, triggerEl) {
        if (ddb && ddb.dropDown) {
            var popupEl = ddb.dropDown.element;
            if (popupEl) {
                var btnRect = triggerEl.getBoundingClientRect();
                var popupRect = popupEl.getBoundingClientRect();
                popupEl.style.left = (this.parent.enableRtl ? btnRect.left : btnRect.right - popupRect.width) + "px";
            }
        }
    };
    SpreadsheetComment.prototype.handleInitialCancel = function (ele) {
        if (ele) {
            var container = this.getContainer(ele);
            var indices = this.getIndexesFromContainer(container);
            var sheet = this.parent.getActiveSheet();
            if (indices) {
                var rowIndex = indices[0], columnIndex = indices[1];
                var cell = getCell(rowIndex, columnIndex, sheet);
                if (!cell || !cell.comment) {
                    this.detachCommentIndicator(rowIndex, columnIndex);
                }
            }
            if (container) {
                EventHandler.remove(container, 'mouseout', this.mouseOut);
                this.unbindContainerEvents(container);
                var host = this.getBodyHost(container);
                if (host) {
                    this.unbindReplyHover(host);
                }
                detach(container);
                if (this.isReviewPaneVisible && container.classList.contains('e-thread-draft')) {
                    if (!sheet.comments || !sheet.comments.length) {
                        this.renderReviewBody();
                    }
                }
            }
            if (this.activeReplyDdb) {
                this.activeReplyDdb.destroy();
                this.activeReplyDdb = null;
            }
            this.isCommentVisible = false;
            this.activeCommentCell = null;
            this.isEditing = false;
        }
    };
    SpreadsheetComment.prototype.onThreadMenuSelect = function (event, sourceEl) {
        var l10n = this.parent.serviceLocator.getService(locale);
        var text = event.item.text;
        if (text === l10n.getConstant('EditComment')) {
            this.beginEdit(false, undefined, sourceEl);
        }
        else if (text === l10n.getConstant('ResolveThread')) {
            this.setThreadResolved(true, sourceEl);
        }
        else {
            this.deleteComment({ sourceEl: sourceEl });
        }
    };
    SpreadsheetComment.prototype.createBodyContent = function (thread, rebuild, inPane, cId) {
        if (thread && thread.createdTime instanceof Date) {
            thread.createdTime = getISOTime(thread.createdTime);
            if (thread.replies) {
                thread.replies.forEach(function (reply) {
                    if (reply.createdTime && reply.createdTime instanceof Date) {
                        reply.createdTime = getISOTime(reply.createdTime);
                    }
                });
            }
        }
        var dataSource = thread ? this.convertThreadToListItems(thread) : [];
        if (inPane) {
            var host = this.parent.createElement('div', { className: 'e-comment-body' });
            if (Browser.isDevice) {
                host.classList.add('e-device-comment');
            }
            this.initListView(host, dataSource, true);
            if (!thread.isResolved && !Browser.isDevice) {
                this.bindReplyHover(host, cId);
            }
            return host;
        }
        if (!this.bodyHost) {
            this.bodyHost = this.parent.createElement('div', { className: 'e-comment-body' });
        }
        if (!this.commentListView) {
            this.commentListView = this.initListView(this.bodyHost, dataSource, false);
        }
        else if (rebuild) {
            this.commentListView.setProperties({ dataSource: dataSource }, true);
            this.commentListView.refresh();
        }
        if (!thread.isResolved && !Browser.isDevice) {
            this.bindReplyHover(this.bodyHost);
        }
        return this.bodyHost;
    };
    SpreadsheetComment.prototype.initListView = function (host, dataSource, registerForCleanup) {
        var _this = this;
        var itemTemplate = function (data) {
            var l10n = _this.parent.serviceLocator.getService(locale);
            var actionText = l10n.getConstant('CommentAction');
            var root = _this.parent.createElement('div', {
                className: "e-comment-item " + data.type,
                attrs: __assign({ 'data-id': data.id }, (data.type === 'reply' ? { 'data-reply-id': data.id } : {}))
            });
            var renderTextAndTimestamp = function (text, createdTime, parent) {
                var textEl = _this.parent.createElement('div', { className: 'e-comment-text' });
                textEl.textContent = text;
                var tsEl = _this.parent.createElement('span', { className: 'e-comment-timestamp' });
                tsEl.textContent = createdTime ? new Date(createdTime + 'z').toLocaleDateString(_this.parent.locale, {
                    month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit'
                }) : '';
                parent.appendChild(textEl);
                parent.appendChild(tsEl);
            };
            if (data.type === 'initial') {
                renderTextAndTimestamp(data.text, data.createdTime, root);
                return [root];
            }
            var row = _this.parent.createElement('div', { className: 'e-comment-reply-row' });
            var avatarWrap = _this.parent.createElement('div', { className: 'e-comment-avatar-wrap' });
            var authorName = data.author;
            var avatarEl = _this.getAvatar(authorName);
            avatarWrap.appendChild(avatarEl);
            var col = _this.parent.createElement('div', { className: 'e-comment-reply-col' });
            var header = _this.parent.createElement('div', { className: 'e-comment-header-wrap' });
            var titleWrap = _this.parent.createElement('div', { className: 'e-comment-title-wrap' });
            var title = _this.parent.createElement('div', { className: 'e-comment-title' });
            title.textContent = authorName;
            titleWrap.appendChild(title);
            var menuBtn = _this.parent.createElement('button', {
                className: 'e-reply-ddb e-flat',
                attrs: { type: 'button', 'data-reply-id': data.id, 'aria-label': actionText }
            });
            if (Browser.isDevice) {
                _this.renderReplyDdb(menuBtn);
            }
            header.appendChild(titleWrap);
            header.appendChild(menuBtn);
            var content = _this.parent.createElement('div', { className: 'e-comment-reply-content' });
            renderTextAndTimestamp(data.text, data.createdTime, content);
            col.appendChild(header);
            col.appendChild(content);
            row.appendChild(avatarWrap);
            row.appendChild(col);
            root.appendChild(row);
            return [root];
        };
        enableRipple(false);
        var listView = new ListView({
            dataSource: dataSource,
            template: itemTemplate,
            cssClass: 'e-comment-listview',
            enableRtl: this.parent.enableRtl,
            enableVirtualization: true,
            height: '100%',
            select: function (args) {
                if (_this.isReviewPaneVisible) {
                    _this.updateCellSelction(args);
                }
            }
        });
        listView.createElement = this.parent.createElement;
        /* eslint-disable */
        listView.isInternalTemplate = true;
        /* eslint-enable */
        listView.appendTo(host);
        if (registerForCleanup) {
            this.reviewInstances.push({ destroy: function () { listView.destroy(); } });
        }
        return listView;
    };
    SpreadsheetComment.prototype.renderReplyDdb = function (btn) {
        var _this = this;
        if (this.isEditing) {
            btn.style.visibility = 'hidden';
            return;
        }
        if (btn.dataset.ddbMounted === 'true') {
            return;
        }
        var l10n = this.parent.serviceLocator.getService(locale);
        var items = [
            { id: 'edit-reply', text: l10n.getConstant('EditComment'), iconCss: 'e-icons e-edit' },
            { id: 'delete-reply', text: l10n.getConstant('DeleteComment'), iconCss: 'e-icons e-trash' }
        ];
        var ddb = new DropDownButton({
            items: items,
            createPopupOnClick: true,
            iconCss: 'e-icons e-more-horizontal-1',
            cssClass: 'e-caret-hide e-menu-popup',
            enableRtl: this.parent.enableRtl,
            select: function (args) {
                var replyId = btn.getAttribute('data-reply-id') || '';
                _this.onReplyMenuSelect(args, replyId, btn);
            },
            open: function () { return _this.setPopupPosition(ddb, btn); }
        });
        ddb.createElement = this.parent.createElement;
        ddb.appendTo(btn);
        btn.dataset.ddbMounted = 'true';
        this.activeReplyDdb = ddb;
    };
    SpreadsheetComment.prototype.onReplyMenuSelect = function (args, replyId, sourceEl) {
        var l10n = this.parent.serviceLocator.getService(locale);
        var text = args.item.text;
        if (text === l10n.getConstant('EditComment')) {
            this.beginEdit(true, replyId, sourceEl);
        }
        else {
            this.deleteReplyById(replyId, sourceEl);
        }
    };
    SpreadsheetComment.prototype.createFooterContent = function (rowIdx, colIdx, initial) {
        var l10n = this.parent.serviceLocator.getService(locale);
        var footer = this.parent.createElement('div', { className: 'e-comment-footer' });
        var cell = getCell(rowIdx, colIdx, this.parent.getActiveSheet());
        if (cell && cell.comment && cell.comment.isResolved === true) {
            return footer;
        }
        footer.setAttribute('data-mode', initial ? 'initial' : 'reply');
        var textArea = this.parent.createElement('textarea', {
            className: 'e-comment-input',
            attrs: { placeholder: initial ? l10n.getConstant('AddComment') : l10n.getConstant('Reply'), rows: '1', name: 'footerTextArea' }
        });
        textArea.style.height = '32px';
        var btnBar = this.parent.createElement('div', { className: 'e-comment-btn' });
        footer.appendChild(textArea);
        footer.appendChild(btnBar);
        if (initial) {
            this.ensureFooterButtons(footer, initial);
            this.syncFooterPostState(footer, textArea);
        }
        this.wireFooterEvents(footer);
        return footer;
    };
    SpreadsheetComment.prototype.convertThreadToListItems = function (thread) {
        var items = [];
        items.push({
            id: thread.id, type: 'initial', author: thread.author || 'Guest User',
            text: thread.text, createdTime: thread.createdTime
        });
        var replies = thread.replies || [];
        if (replies.length > 0) {
            replies.forEach(function (reply) {
                items.push({
                    id: reply.id || getUniqueID('e_spreadsheet_reply'), type: 'reply',
                    author: reply.author || 'Guest User', text: reply.text, createdTime: reply.createdTime
                });
            });
        }
        return items;
    };
    SpreadsheetComment.prototype.postComment = function (rowIdx, colIdx, commentText, container) {
        if (!commentText) {
            return;
        }
        var timeStampValue = getISOTime();
        var actionFromPanel = container && container.classList.contains('e-pane-container');
        var cell = getCell(rowIdx, colIdx, this.parent.getActiveSheet());
        if (cell && cell.comment) {
            var thread = JSON.parse(JSON.stringify(cell.comment));
            if (!Array.isArray(thread.replies)) {
                thread.replies = [];
            }
            var reply = {
                id: getUniqueID('e_spreadsheet_reply'),
                author: this.parent.author || 'Guest User',
                text: commentText,
                createdTime: timeStampValue
            };
            thread.replies.push(reply);
            this.saveComment(rowIdx, colIdx, thread, 'addReply', actionFromPanel);
            var body = container.querySelector('.e-comment-body');
            var targetListView = void 0;
            if (body) {
                targetListView = getComponent(body, 'listview');
            }
            else {
                targetListView = this.commentListView;
            }
            if (targetListView) {
                var avatarEl = this.getAvatar(reply.author);
                targetListView.addItem([{
                        id: reply.id,
                        type: 'reply',
                        author: reply.author,
                        text: reply.text,
                        createdTime: reply.createdTime,
                        avatarHtml: avatarEl.outerHTML
                    }]);
                if (body) {
                    body.scrollTop = body.scrollHeight;
                }
            }
            return;
        }
        var id = getUniqueID('e_spreadsheet_comment');
        var newThread = {
            id: id,
            author: this.parent.author || 'Guest User',
            text: commentText,
            createdTime: timeStampValue,
            isResolved: false,
            replies: []
        };
        this.saveComment(rowIdx, colIdx, newThread, 'addComment', actionFromPanel);
        var header = container.querySelector('.e-comment-header');
        if (header && !header.querySelector('.e-comment-actions')) {
            var headerWrap = header.querySelector('.e-comment-header-wrap');
            if (headerWrap) {
                this.renderHeaderActions(headerWrap, false, getCellAddress(rowIdx, colIdx));
            }
        }
        if (container) {
            var body = this.createBodyContent(newThread, true, this.isReviewPaneVisible);
            var footer = container.querySelector('.e-comment-footer');
            if (footer && body && body.parentElement !== container) {
                container.insertBefore(body, footer);
            }
            else if (footer && body && footer.previousElementSibling !== body) {
                container.insertBefore(body, footer);
            }
        }
        if (this.isReviewPaneVisible) {
            if (container && container.classList.contains('e-thread-draft')) {
                this.destoryCommentDdb(container);
                container.remove();
            }
        }
    };
    SpreadsheetComment.prototype.beginEdit = function (isReply, replyId, sourceEl) {
        var _this = this;
        var container = this.getContainer(sourceEl);
        var localBodyHost = this.getBodyHost(container);
        if (this.isEditing || !container || !localBodyHost) {
            return;
        }
        var idx = this.getIndexesFromContainer(container);
        if (idx) {
            var cell = getCell(idx[0], idx[1], this.parent.getActiveSheet());
            var th = cell && cell.comment;
            if (th && th.isResolved) {
                return;
            }
        }
        var itemSelector = isReply ? ".e-comment-item.reply[data-reply-id=\"" + replyId + "\"]" : '.e-comment-item.initial';
        var itemEl = localBodyHost.querySelector(itemSelector);
        if (!itemEl) {
            return;
        }
        var textEl = itemEl.querySelector('.e-comment-text');
        if (!textEl) {
            return;
        }
        var originalText = textEl.textContent || '';
        var l10n = this.parent.serviceLocator.getService(locale);
        var editorWrap = this.parent.createElement('div', { className: 'e-comment-edit-wrap' });
        var textArea = this.parent.createElement('textarea', {
            className: 'e-comment-input e-comment-edit-input',
            attrs: { rows: '1', name: 'editTextArea' }
        });
        EventHandler.add(textArea, 'focus', function () { textArea.classList.add('active'); }, this);
        EventHandler.add(textArea, 'blur', function () { textArea.classList.remove('active'); }, this);
        textArea.value = originalText;
        this.adjustTextareaHeight(textArea, true);
        var tsEle = itemEl.querySelector('.e-comment-timestamp');
        var tsValue = '';
        if (tsEle) {
            tsValue = tsEle.style.display;
            tsEle.style.display = 'none';
        }
        var btnBar = this.parent.createElement('div', { className: 'e-comment-btn' });
        var postBtnEl = this.parent.createElement('button', {
            className: 'e-comment-post',
            attrs: { type: 'button', 'aria-label': 'Post', title: l10n.getConstant('EditComment') }
        });
        var postBtn = new Button({ iconCss: 'e-icons e-send', isPrimary: true }, postBtnEl);
        postBtn.createElement = this.parent.createElement;
        var cancelBtnEl = this.parent.createElement('button', {
            className: 'e-comment-cancel',
            attrs: { type: 'button', 'aria-label': 'Cancel', title: l10n.getConstant('Cancel') }
        });
        var cancelBtn = new Button({ cssClass: 'e-flat', iconCss: 'e-icons e-close' }, cancelBtnEl);
        cancelBtn.createElement = this.parent.createElement;
        EventHandler.add(textArea, 'input', function () { return _this.adjustTextareaHeight(textArea, true); }, this);
        var postCommentFn = function () {
            _this.applyInlineEdit(isReply, textArea.value, textEl, editorWrap, originalText, replyId, container);
        };
        EventHandler.add(postBtn.element, 'click', postCommentFn, this);
        var cancelBtnFn = function () {
            textEl.textContent = originalText;
            textEl.style.display = '';
            editorWrap.remove();
            _this.endEdit(container);
        };
        EventHandler.add(cancelBtn.element, 'click', cancelBtnFn, this);
        btnBar.appendChild(postBtnEl);
        btnBar.appendChild(cancelBtnEl);
        editorWrap.appendChild(textArea);
        editorWrap.appendChild(btnBar);
        textEl.style.display = 'none';
        if (textEl.parentElement) {
            textEl.parentElement.insertBefore(editorWrap, textEl.nextSibling);
        }
        this.editingState = {
            isReply: isReply, replyId: replyId, textEl: textEl, editorWrap: editorWrap, originalText: originalText, tsEle: tsEle, tsValue: tsValue,
            container: container, textHost: localBodyHost, addrIdx: idx
        };
        this.isEditing = true;
        this.setTextAreaState(container, true);
        container.classList.add('e-comment-editing');
        var header = container.querySelector('.e-comment-header');
        if (header) {
            var headerWrap = header.querySelector('.e-comment-header-wrap');
            if (headerWrap) {
                if (idx && idx.length === 2) {
                    this.renderHeaderActions(headerWrap, false, getCellAddress(idx[0], idx[1]));
                }
            }
        }
        var replyBtns = localBodyHost.querySelectorAll('.e-reply-ddb');
        if (replyBtns) {
            replyBtns.forEach(function (btn) {
                btn.style.visibility = 'hidden';
            });
        }
        getUpdateUsingRaf(function () {
            _this.adjustTextareaHeight(textArea, true);
            textArea.focus();
            var len = textArea.value.length;
            textArea.setSelectionRange(len, len);
        });
    };
    SpreadsheetComment.prototype.applyInlineEdit = function (isReply, newText, textEl, editorWrap, originalText, replyId, container) {
        var finalText = newText || originalText;
        textEl.textContent = finalText;
        textEl.style.display = '';
        editorWrap.remove();
        var indices = this.getIndexesFromContainer(container || null);
        if (indices && indices.length === 2) {
            var row = indices[0], col = indices[1];
            var cell = getCell(row, col, this.parent.getActiveSheet());
            var actionFromPanel = container && container.classList.contains('e-pane-container');
            if (cell && cell.comment) {
                var thread = JSON.parse(JSON.stringify(cell.comment));
                if (isReply) {
                    if (!replyId || !thread.replies) {
                        this.endEdit(container);
                        return;
                    }
                    var idx = thread.replies.findIndex(function (r) { return r.id === replyId; });
                    if (idx > -1) {
                        thread.replies[idx] = __assign({}, thread.replies[idx], { text: finalText });
                        this.saveComment(row, col, thread, 'editReply', actionFromPanel);
                    }
                }
                else {
                    var updatedThread = __assign({}, thread, { text: finalText });
                    this.saveComment(row, col, updatedThread, 'editComment', actionFromPanel);
                }
            }
        }
        this.endEdit(container);
    };
    SpreadsheetComment.prototype.endEdit = function (container) {
        if (this.editingState && this.editingState.tsEle) {
            this.editingState.tsEle.style.display = isNullOrUndefined(this.editingState.tsValue) ? '' : this.editingState.tsValue;
        }
        var targetContainer = container || (this.editingState && this.editingState.container);
        if (targetContainer) {
            targetContainer.classList.remove('e-comment-editing');
            this.setTextAreaState(targetContainer, false);
            var header = targetContainer.querySelector('.e-comment-header');
            if (header) {
                var headerWrap = header.querySelector('.e-comment-header-wrap');
                if (headerWrap) {
                    var indices = this.getIndexesFromContainer(targetContainer);
                    if (indices && indices.length === 2) {
                        var prev = this.isEditing;
                        this.isEditing = false;
                        this.renderHeaderActions(headerWrap, false, getCellAddress(indices[0], indices[1]));
                        this.isEditing = prev;
                    }
                }
            }
            var localBodyHost = this.getBodyHost(targetContainer);
            if (localBodyHost) {
                var replyBtns = localBodyHost.querySelectorAll('.e-reply-ddb');
                replyBtns.forEach(function (btn) {
                    btn.style.visibility = '';
                });
            }
        }
        this.isEditing = false;
        this.editingState = null;
    };
    SpreadsheetComment.prototype.deleteReplyById = function (replyId, sourceEl) {
        if (replyId && sourceEl) {
            var container = this.getContainer(sourceEl);
            var host = this.getBodyHost(container);
            if (container && host) {
                var indexes = this.getIndexesFromContainer(container);
                if (indexes && indexes.length === 2) {
                    var row = indexes[0], col = indexes[1];
                    var cell = getCell(row, col, this.parent.getActiveSheet());
                    if (cell && cell.comment) {
                        var thread = JSON.parse(JSON.stringify(cell.comment));
                        if (thread.replies) {
                            var idx = thread.replies.findIndex(function (r) { return r.id === replyId; });
                            if (idx > -1) {
                                thread.replies.splice(idx, 1);
                                this.saveComment(row, col, thread, 'deleteReply', container.classList.contains('e-pane-container'));
                                var targetListView = getComponent(host, 'listview');
                                if (targetListView) {
                                    targetListView.removeItem({ id: replyId });
                                }
                            }
                        }
                    }
                }
            }
        }
    };
    SpreadsheetComment.prototype.setTextAreaState = function (container, disabled) {
        if (container) {
            var l10n = this.parent.serviceLocator.getService(locale);
            var textArea = container.querySelector('.e-comment-footer .e-comment-input');
            if (textArea) {
                if (disabled) {
                    textArea.disabled = true;
                    textArea.placeholder = l10n.getConstant('CommentEditingInProgress');
                }
                else {
                    textArea.disabled = false;
                    textArea.placeholder = l10n.getConstant('Reply');
                    this.adjustTextareaHeight(textArea, false);
                }
            }
        }
    };
    SpreadsheetComment.prototype.adjustTextareaHeight = function (textArea, isEdit) {
        if (textArea) {
            var cs = getComputedStyle(textArea);
            var linePx = parseFloat(cs.lineHeight);
            if (isNaN(linePx)) {
                var fontSize = parseFloat(cs.fontSize) || 14;
                linePx = Math.round(fontSize * 1.2);
            }
            var padTB = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
            var borderTB = (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
            var minLines = 1;
            var maxLines = 5;
            if (!isEdit && textArea.value.trim().length === 0) {
                textArea.style.height = (minLines * linePx) + padTB + borderTB + "px";
                textArea.style.overflowY = 'hidden';
                return;
            }
            textArea.style.height = 'auto';
            var contentHeight = Math.max(0, textArea.scrollHeight - padTB);
            var neededLines = Math.max(1, Math.ceil(contentHeight / Math.max(1, linePx)));
            var clampedLines = Math.max(minLines, Math.min(maxLines, neededLines));
            var finalHeight = (clampedLines * linePx) + padTB + borderTB;
            textArea.style.height = finalHeight + "px";
            textArea.style.overflowY = 'hidden';
        }
    };
    SpreadsheetComment.prototype.saveComment = function (rIdx, cIdx, comment, actionName, isPanel) {
        if (comment && !comment.address) {
            comment.address = [rIdx, cIdx];
        }
        var sheet = this.parent.getActiveSheet();
        var address = getSheetName(this.parent, this.parent.activeSheetIndex) + '!' + getRangeAddress([rIdx, cIdx]);
        var eventArgs = { comment: JSON.parse(JSON.stringify(comment)), address: address, cancel: false };
        this.parent.notify(beginAction, { eventArgs: eventArgs, action: actionName });
        if (eventArgs.cancel) {
            return;
        }
        comment = JSON.parse(JSON.stringify(eventArgs.comment));
        this.processSheetComments({ sheet: sheet, comment: comment, isDelete: false });
        var cancel = updateCell(this.parent, sheet, {
            rowIdx: rIdx, colIdx: cIdx, preventEvt: true, cell: { comment: comment }
        });
        if (!cancel) {
            var cell = getCell(rIdx, cIdx, sheet, null, true);
            cell.comment = comment;
            if (actionName === 'addComment') {
                this.parent.setUsedRange(rIdx, cIdx, sheet);
            }
            var td = this.parent.getCell(rIdx, cIdx);
            if (td && !td.querySelector('.e-comment-indicator')) {
                this.createCommentIndicator({ targetEle: td, rIdx: rIdx, cIdx: cIdx });
            }
            if (this.isReviewPaneVisible) {
                if (actionName === 'addComment') {
                    this.insertThreadIntoPanel(comment);
                    this.scrollToThreadInPanel(comment.id);
                }
                else if (!isPanel && actionName !== 'addComment') {
                    this.syncThreadInPanel(comment);
                }
            }
            this.parent.notify(completeAction, { eventArgs: eventArgs, action: actionName });
        }
    };
    SpreadsheetComment.prototype.detachCommentIndicator = function (rowIdx, colIdx) {
        var cellElement = this.parent.getCell(rowIdx, colIdx);
        if (cellElement) {
            var indicator = cellElement.querySelector('.e-comment-indicator');
            if (indicator) {
                EventHandler.remove(indicator, 'mouseover', this.mouseOver);
                EventHandler.remove(indicator, 'mouseout', this.mouseOut);
                delete indicator.dataset.commentListenersAdded;
                delete indicator.dataset.commentRowIndex;
                delete indicator.dataset.commentColIndex;
                detach(indicator);
            }
        }
    };
    SpreadsheetComment.prototype.setCommentContainerPosition = function (commentContainer, cellRect) {
        var selectAllCell = this.parent.element.getElementsByClassName('e-select-all-cell')[0];
        var scroller = this.parent.element.getElementsByClassName('e-scroller')[0];
        var sheetClientRect = this.parent.element.getElementsByClassName('e-sheet')[0].getBoundingClientRect();
        var elementClientRect = this.parent.element.getBoundingClientRect();
        var elementPosition = this.parent.element.style.getPropertyValue('position');
        var offsetTop = (elementPosition === 'absolute' ? 0 : this.parent.element.offsetTop);
        var offsetLeft = (elementPosition === 'absolute' ? 0 : this.parent.element.offsetLeft);
        commentContainer.style.position = 'absolute';
        var topPos = cellRect.top - (elementClientRect.top - offsetTop);
        if (!isNullOrUndefined(scroller)) {
            var spaceToBottom = scroller.getBoundingClientRect().top - (cellRect.top);
            if (spaceToBottom < commentContainer.offsetHeight) {
                topPos -= (commentContainer.offsetHeight - spaceToBottom + 5);
            }
            else if (!isNullOrUndefined(selectAllCell) && cellRect.top < selectAllCell.getBoundingClientRect().bottom) {
                topPos = selectAllCell.getBoundingClientRect().bottom - (elementClientRect.top - offsetTop) + 5;
            }
        }
        if (topPos < 0) {
            topPos = 5;
        }
        commentContainer.style.top = topPos + "px";
        var leftPos;
        var preferredWidth = 244;
        var actualWidth = preferredWidth;
        var spaceToRight = sheetClientRect.width - (cellRect.left + cellRect.width - sheetClientRect.left);
        if (spaceToRight > preferredWidth + 5) {
            leftPos = cellRect.left + cellRect.width - (elementClientRect.left - offsetLeft);
        }
        else {
            leftPos = cellRect.left - (elementClientRect.left - offsetLeft) - preferredWidth;
            if (leftPos < 0) {
                leftPos = 5;
                actualWidth = elementClientRect.width - 10;
            }
        }
        commentContainer.style.left = leftPos + "px";
        commentContainer.style.width = actualWidth + "px";
    };
    SpreadsheetComment.prototype.deleteComment = function (args) {
        var container;
        var rIdx;
        var cIdx;
        if (args && args.sourceEl) {
            container = this.getContainer(args.sourceEl);
        }
        if (args && !isNullOrUndefined(args.rowIndex) && !isNullOrUndefined(args.columnIndex)) {
            rIdx = args.rowIndex;
            cIdx = args.columnIndex;
        }
        else {
            var index = this.getIndexesFromContainer(container);
            rIdx = index[0];
            cIdx = index[1];
        }
        var sheet = this.parent.getActiveSheet();
        var cell = getCell(rIdx, cIdx, sheet);
        this.detachCommentIndicator(rIdx, cIdx);
        if (!isNullOrUndefined(cell) && cell.comment) {
            var address = getSheetName(this.parent, this.parent.activeSheetIndex) + '!' +
                getRangeAddress([rIdx, cIdx]);
            var eventArgs = { comment: cell.comment, address: address, cancel: false };
            this.parent.notify(beginAction, { eventArgs: eventArgs, action: 'deleteComment' });
            if (eventArgs.cancel) {
                return;
            }
            this.processSheetComments({ sheet: sheet, id: cell.comment.id, isDelete: true });
            delete cell.comment;
            updateCell(this.parent, sheet, { rowIdx: rIdx, colIdx: cIdx, preventEvt: true, cell: cell });
            if (this.isReviewPaneVisible) {
                this.refreshReviewListFromSheet();
            }
            eventArgs.comment = null;
            this.parent.notify(completeAction, { eventArgs: eventArgs, action: 'deleteComment' });
        }
        if (container) {
            EventHandler.remove(container, 'mouseout', this.mouseOut);
            this.unbindContainerEvents(container);
            var host = this.getBodyHost(container);
            if (host) {
                this.unbindReplyHover(host);
                var lv = getComponent(host, 'listview');
                if (lv) {
                    lv.destroy();
                }
            }
            var footerEl = container.querySelector('.e-comment-footer');
            if (footerEl) {
                this.unwireFooterEvents(footerEl);
                this.removeFooterButtons(footerEl);
            }
            if (this.activeReplyDdb) {
                this.activeReplyDdb.destroy();
                this.activeReplyDdb = null;
            }
            this.destoryCommentDdb(container);
            detach(container);
        }
        if (this.isEditing) {
            this.isEditing = false;
            this.editingState = null;
        }
    };
    SpreadsheetComment.prototype.replyToComment = function () {
        this.initiateComment();
        var container = this.getCommentContainer();
        if (container) {
            var textArea = container.querySelector('.e-comment-footer .e-comment-input');
            if (textArea) {
                textArea.focus();
                textArea.select();
                this.adjustTextareaHeight(textArea, false);
                if (!container.classList.contains('active')) {
                    container.classList.add('active');
                }
            }
        }
    };
    SpreadsheetComment.prototype.setThreadResolved = function (resolved, sourceEl) {
        var container = this.getContainer(sourceEl);
        var indexes = this.getIndexesFromContainer(container);
        if (indexes) {
            var rowIndex = indexes[0], columnIndex = indexes[1];
            var cell = getCell(rowIndex, columnIndex, this.parent.getActiveSheet());
            if (cell && cell.comment) {
                var thread = JSON.parse(JSON.stringify(cell.comment));
                if (thread.isResolved !== resolved) {
                    var updated = __assign({}, thread, { isResolved: resolved });
                    var actionFromPanel = container && container.classList.contains('e-pane-container');
                    this.saveComment(rowIndex, columnIndex, updated, resolved ? 'resolveComment' : 'reopenComment', actionFromPanel);
                    this.renderThreadContainer(rowIndex, columnIndex, updated, container);
                    if (this.isReviewPaneVisible && this.reviewFilter !== 'all') {
                        if (!this.filterMatches(updated)) {
                            this.removeThreadFromPanel(updated.id);
                        }
                    }
                }
            }
        }
    };
    SpreadsheetComment.prototype.renderThreadContainer = function (rIdx, cIdx, thread, container) {
        if (container) {
            var address = getCellAddress(rIdx, cIdx);
            var oldHeader = container.querySelector('.e-comment-header');
            var newHeader = this.createheaderContent(false, address, thread);
            if (oldHeader && newHeader) {
                oldHeader.replaceWith(newHeader);
            }
            var bodyEl = container.querySelector('.e-comment-body');
            var existingFooter = container.querySelector('.e-comment-footer');
            if (thread.isResolved) {
                if (existingFooter) {
                    this.unwireFooterEvents(existingFooter);
                    this.removeFooterButtons(existingFooter);
                    existingFooter.remove();
                }
                container.classList.add('e-thread-resolved');
                this.removeReplyButtons(bodyEl);
                this.setTextAreaState(container, true);
                this.renderResolvedWrap(container, rIdx, cIdx, thread.author || (this.parent.author || 'Guest User'));
            }
            else {
                if (!existingFooter) {
                    var newFooter = this.createFooterContent(rIdx, cIdx, false);
                    if (newFooter) {
                        if (bodyEl && bodyEl.nextSibling) {
                            container.insertBefore(newFooter, bodyEl.nextSibling);
                        }
                        else {
                            container.appendChild(newFooter);
                        }
                    }
                }
                container.classList.remove('e-thread-resolved');
                this.addReplyButtons(bodyEl);
                this.setTextAreaState(container, false);
                ['.e-comment-resolved-wrap', '.e-comment-divider'].forEach(function (selector) {
                    var element = container.querySelector(selector);
                    if (element) {
                        element.remove();
                    }
                });
            }
        }
    };
    SpreadsheetComment.prototype.renderResolvedContent = function (address, author) {
        var resolvedHeader = this.parent.createElement('div', { className: 'e-comment-resolved-wrap e-comment-header' });
        var avatar = this.getAvatar(author);
        var headerWrap = this.parent.createElement('div', { className: 'e-comment-header-wrap' });
        var titleWrap = this.parent.createElement('div', { className: 'e-comment-title-wrap' });
        var titleEl = this.parent.createElement('div', { className: 'e-comment-title' });
        titleEl.textContent = author || (this.parent.author || 'Guest User');
        var cellRefEl = this.parent.createElement('div', { className: 'e-comment-cellref' });
        cellRefEl.textContent = address;
        titleWrap.appendChild(titleEl);
        headerWrap.appendChild(titleWrap);
        headerWrap.appendChild(cellRefEl);
        resolvedHeader.appendChild(avatar);
        resolvedHeader.appendChild(headerWrap);
        return resolvedHeader;
    };
    SpreadsheetComment.prototype.renderResolvedWrap = function (container, rIdx, cIdx, author) {
        if (!container || container.querySelector('.e-comment-resolved-wrap')) {
            return;
        }
        var bodyEl = container.querySelector('.e-comment-body');
        if (bodyEl) {
            var divider = this.parent.createElement('div', { className: 'e-comment-divider' });
            var wrap = this.renderResolvedContent(getCellAddress(rIdx, cIdx), author);
            container.insertBefore(divider, bodyEl);
            container.insertBefore(wrap, bodyEl);
        }
    };
    SpreadsheetComment.prototype.getContainer = function (sourceEl) {
        return sourceEl && sourceEl.closest('.e-comment-container, .e-pane-container');
    };
    SpreadsheetComment.prototype.getBodyHost = function (container) {
        return container && container.querySelector('.e-comment-body');
    };
    SpreadsheetComment.prototype.getCommentContainer = function () {
        return this.parent.element.querySelector('.e-comment-container');
    };
    SpreadsheetComment.prototype.getIndexesFromContainer = function (container) {
        var index;
        if (container) {
            var cellRefEl = container.querySelector('.e-comment-cellref');
            var refText = cellRefEl && cellRefEl.textContent ? cellRefEl.textContent.trim() : '';
            if (refText) {
                index = getCellIndexes(refText);
            }
            else if (this.editingState && this.editingState.container === container && Array.isArray(this.editingState.addrIdx)) {
                index = this.editingState.addrIdx.slice();
            }
        }
        if (!index && this.activeCommentCell && this.activeCommentCell.length === 2) {
            index = [this.activeCommentCell[0], this.activeCommentCell[1]];
        }
        else if (!index) {
            index = getCellIndexes(this.parent.getActiveSheet().activeCell);
        }
        return index;
    };
    // Events handling for comment containers
    SpreadsheetComment.prototype.bindContainerEvents = function (container) {
        if (container) {
            EventHandler.remove(container, 'focusin', this.onContainerFocusIn);
            EventHandler.add(container, 'focusin', this.onContainerFocusIn, this);
            EventHandler.remove(container, 'focusout', this.onContainerFocusOut);
            EventHandler.add(container, 'focusout', this.onContainerFocusOut, this);
        }
    };
    SpreadsheetComment.prototype.unbindContainerEvents = function (container) {
        if (container) {
            EventHandler.remove(container, 'focusin', this.onContainerFocusIn);
            EventHandler.remove(container, 'focusout', this.onContainerFocusOut);
        }
    };
    SpreadsheetComment.prototype.onContainerFocusIn = function (evt) {
        var container = evt.currentTarget;
        if (container && !container.classList.contains('active')) {
            container.classList.add('active');
        }
    };
    SpreadsheetComment.prototype.onContainerFocusOut = function (evt) {
        var container = evt.currentTarget;
        var related = evt.relatedTarget;
        if (container) {
            if (!related || !container.contains(related)) {
                if (container.classList.contains('active')) {
                    container.classList.remove('active');
                }
            }
        }
    };
    SpreadsheetComment.prototype.bindReplyHover = function (host, containerId) {
        if (host) {
            if (containerId) {
                host.setAttribute('data-reply-container-id', containerId);
            }
            EventHandler.remove(host, 'mouseover', this.onReplyHoverMouseOver);
            EventHandler.add(host, 'mouseover', this.onReplyHoverMouseOver, this);
            EventHandler.remove(host, 'focusin', this.onReplyHoverFocusIn);
            EventHandler.add(host, 'focusin', this.onReplyHoverFocusIn, this);
        }
    };
    SpreadsheetComment.prototype.unbindReplyHover = function (host) {
        if (host) {
            EventHandler.remove(host, 'mouseover', this.onReplyHoverMouseOver);
            EventHandler.remove(host, 'focusin', this.onReplyHoverFocusIn);
        }
    };
    SpreadsheetComment.prototype.onReplyHoverMouseOver = function (evt) {
        this.handleReplyHover(evt.target);
    };
    SpreadsheetComment.prototype.onReplyHoverFocusIn = function (evt) {
        this.handleReplyHover(evt.target);
    };
    SpreadsheetComment.prototype.handleReplyHover = function (target) {
        if (this.isEditing) {
            return;
        }
        var targetEl = target;
        if (!targetEl) {
            return;
        }
        var container;
        if (this.isReviewPaneVisible) {
            var bodyHost = targetEl.closest('.e-comment-body');
            if (bodyHost) {
                var id = bodyHost.getAttribute('data-reply-container-id');
                if (id) {
                    container = this.parent.element.querySelector('.' + id);
                }
            }
        }
        else {
            container = this.getCommentContainer();
        }
        if (container && container.classList.contains('e-thread-resolved')) {
            return;
        }
        var btn = targetEl.querySelector('.e-reply-ddb');
        if (btn) {
            this.renderReplyDdb(btn);
        }
    };
    SpreadsheetComment.prototype.removeReplyButtons = function (bodyEl) {
        var buttons = bodyEl.querySelectorAll('.e-reply-ddb');
        buttons.forEach(function (btn) {
            var ddb = getComponent(btn, 'dropdown-btn');
            if (ddb) {
                ddb.destroy();
            }
            btn.remove();
        });
    };
    SpreadsheetComment.prototype.addReplyButtons = function (bodyEl) {
        var _this = this;
        var l10n = this.parent.serviceLocator.getService(locale);
        var actionText = l10n.getConstant('CommentAction');
        var replyItems = bodyEl.querySelectorAll('.e-comment-item.reply');
        replyItems.forEach(function (item) {
            var replyId = item.getAttribute('data-reply-id') || item.getAttribute('data-id') || '';
            var headerWrap = item.querySelector('.e-comment-header-wrap');
            if (headerWrap) {
                if (headerWrap.querySelector('.e-reply-ddb')) {
                    return;
                }
                var menuBtn = _this.parent.createElement('button', {
                    className: 'e-reply-ddb e-flat',
                    attrs: { type: 'button', 'data-reply-id': replyId, 'aria-label': actionText }
                });
                headerWrap.appendChild(menuBtn);
                _this.renderReplyDdb(menuBtn);
            }
        });
    };
    SpreadsheetComment.prototype.onFooterInput = function (e) {
        var textArea = e.currentTarget;
        var footer = textArea.closest('.e-comment-footer');
        if (footer) {
            if (textArea.value.trim().length > 0) {
                this.ensureFooterButtons(footer, footer.getAttribute('data-mode') === 'initial');
            }
            else if (document.activeElement !== textArea) {
                this.removeFooterButtons(footer);
            }
            this.adjustTextareaHeight(textArea, false);
            this.syncFooterPostState(footer, textArea);
        }
    };
    SpreadsheetComment.prototype.onFooterFocus = function (e) {
        var textArea = e.currentTarget;
        textArea.classList.add('active');
        var footer = textArea.closest('.e-comment-footer');
        if (footer) {
            this.ensureFooterButtons(footer, footer.getAttribute('data-mode') === 'initial');
            this.syncFooterPostState(footer, textArea);
        }
    };
    SpreadsheetComment.prototype.onFooterBlur = function (e) {
        var textArea = e.currentTarget;
        textArea.classList.remove('active');
        var footer = textArea.closest('.e-comment-footer');
        if (footer) {
            if (textArea.value.trim().length === 0) {
                this.removeFooterButtons(footer);
                textArea.style.height = '32px';
            }
        }
    };
    SpreadsheetComment.prototype.onFooterClick = function (e) {
        var target = e.target;
        var btn = target.closest('.e-comment-post, .e-comment-cancel');
        if (btn) {
            var footer = btn.closest('.e-comment-footer');
            var container = btn.closest('.e-comment-container, .e-pane-container');
            if (!footer || !container) {
                return;
            }
            var textArea = footer.querySelector('.e-comment-input');
            if (!textArea) {
                return;
            }
            this.isEditing = false;
            if (btn.classList.contains('e-comment-post')) {
                if (btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') {
                    return;
                }
                var idx = this.getIndexesFromContainer(container);
                if (!Array.isArray(idx) || idx.length !== 2) {
                    return;
                }
                var rIdx = idx[0], cIdx = idx[1];
                var text = (textArea.value || '');
                if (text.length === 0) {
                    return;
                }
                this.postComment(rIdx, cIdx, text, container);
                textArea.value = '';
                this.adjustTextareaHeight(textArea, false);
                this.syncFooterPostState(footer, textArea);
                if (footer.getAttribute('data-mode') === 'initial') {
                    footer.setAttribute('data-mode', 'reply');
                    var l10n = this.parent.serviceLocator.getService(locale);
                    textArea.placeholder = l10n.getConstant('Reply');
                }
                this.removeFooterButtons(footer);
            }
            else if (btn.classList.contains('e-comment-cancel')) {
                textArea.value = '';
                this.adjustTextareaHeight(textArea, false);
                this.removeFooterButtons(footer);
                this.syncFooterPostState(footer, textArea);
            }
        }
    };
    SpreadsheetComment.prototype.ensureFooterButtons = function (footer, initial) {
        var btnBar = footer.querySelector('.e-comment-btn');
        if (btnBar) {
            var l10n = this.parent.serviceLocator.getService(locale);
            if (!btnBar.querySelector('.e-comment-post')) {
                var postBtnEl = this.parent.createElement('button', {
                    className: 'e-comment-post',
                    attrs: { type: 'button', 'aria-label': 'Post', title: l10n.getConstant('Post') }
                });
                var postInstance = new Button({ iconCss: 'e-icons e-send', disabled: true }, postBtnEl);
                postInstance.createElement = this.parent.createElement;
                btnBar.appendChild(postBtnEl);
            }
            if (!initial && !btnBar.querySelector('.e-comment-cancel')) {
                var cancelBtnEl = this.parent.createElement('button', {
                    className: 'e-comment-cancel',
                    attrs: { type: 'button', 'aria-label': 'Cancel', title: l10n.getConstant('Cancel') }
                });
                var cancelInstance = new Button({ cssClass: 'e-flat', iconCss: 'e-icons e-close' }, cancelBtnEl);
                cancelInstance.createElement = this.parent.createElement;
                btnBar.appendChild(cancelBtnEl);
            }
        }
    };
    SpreadsheetComment.prototype.removeFooterButtons = function (footer) {
        var btnBar = footer.querySelector('.e-comment-btn');
        if (btnBar) {
            var post = btnBar.querySelector('.e-comment-post');
            var cancel = btnBar.querySelector('.e-comment-cancel');
            var destroyButton = function (ele) {
                requestAnimationFrame(function () {
                    var inst = getComponent(ele, 'btn');
                    if (inst) {
                        inst.destroy();
                    }
                    ele.remove();
                });
            };
            if (post) {
                destroyButton(post);
            }
            if (cancel) {
                destroyButton(cancel);
            }
        }
    };
    SpreadsheetComment.prototype.syncFooterPostState = function (footer, textArea) {
        var btnBar = footer.querySelector('.e-comment-btn');
        if (btnBar) {
            var postBtn = btnBar.querySelector('.e-comment-post');
            var hasContent = textArea.value.trim().length > 0;
            this.isEditing = hasContent;
            if (postBtn) {
                var inst = getComponent(postBtn, 'btn');
                if (inst) {
                    inst.disabled = !hasContent;
                    inst.isPrimary = hasContent;
                    inst.dataBind();
                    inst.element.style.opacity = hasContent ? '1' : '0.5';
                }
            }
        }
    };
    SpreadsheetComment.prototype.wireFooterEvents = function (footer) {
        if (!footer || footer.dataset.footerWired === '1') {
            return;
        }
        var textArea = footer.querySelector('.e-comment-input');
        var btnBar = footer.querySelector('.e-comment-btn');
        if (textArea) {
            EventHandler.add(textArea, 'input', this.onFooterInput, this);
            EventHandler.add(textArea, 'focus', this.onFooterFocus, this);
            EventHandler.add(textArea, 'blur', this.onFooterBlur, this);
        }
        if (btnBar) {
            EventHandler.add(btnBar, 'click', this.onFooterClick, this);
        }
        footer.dataset.footerWired = '1';
    };
    SpreadsheetComment.prototype.unwireFooterEvents = function (footer) {
        if (!footer || footer.dataset.footerWired !== '1') {
            return;
        }
        var textArea = footer.querySelector('.e-comment-input');
        var btnBar = footer.querySelector('.e-comment-btn');
        if (textArea) {
            EventHandler.remove(textArea, 'input', this.onFooterInput);
            EventHandler.remove(textArea, 'focus', this.onFooterFocus);
            EventHandler.remove(textArea, 'blur', this.onFooterBlur);
        }
        if (btnBar) {
            EventHandler.remove(btnBar, 'click', this.onFooterClick);
        }
        delete footer.dataset.footerWired;
    };
    SpreadsheetComment.prototype.commentHandler = function () {
        if (this.isReviewPaneVisible && this.parent.element.querySelector('.e-review-panel')) {
            var sheet = this.parent.getActiveSheet();
            var indexes = getCellIndexes(sheet.activeCell);
            var cell = getCell(indexes[0], indexes[1], sheet);
            var reviewHeaderNewBtn = this.parent.element.querySelector('.e-review-new');
            if (reviewHeaderNewBtn) {
                var newBtnObj = getComponent(reviewHeaderNewBtn, 'btn');
                if (newBtnObj) {
                    newBtnObj.disabled = !!(cell && cell.notes);
                    newBtnObj.dataBind();
                }
            }
            if (cell && cell.comment) {
                this.initiateComment({ rowIndex: indexes[0], columnIndex: indexes[1], isSelection: true });
            }
        }
    };
    SpreadsheetComment.prototype.removeCommentContainer = function () {
        var container = this.parent.element.querySelector('.e-comment-container');
        var rIdx;
        var cIdx;
        if (container) {
            if (container.dataset && container.dataset.commentRowIndex && container.dataset.commentColIndex) {
                rIdx = parseInt(container.dataset.commentRowIndex, 10);
                cIdx = parseInt(container.dataset.commentColIndex, 10);
            }
            var cellEle = this.parent.getCell(rIdx, cIdx);
            if (cellEle) {
                EventHandler.remove(cellEle, 'mouseout', this.mouseOut);
            }
            EventHandler.remove(container, 'mouseout', this.mouseOut);
            this.unbindContainerEvents(container);
            var host = this.getBodyHost(container);
            if (host) {
                this.unbindReplyHover(host);
            }
            var footerEl = container.querySelector('.e-comment-footer');
            if (footerEl) {
                this.unwireFooterEvents(footerEl);
                this.removeFooterButtons(footerEl);
            }
            this.destoryCommentDdb(container);
            detach(container);
            if (!isNullOrUndefined(rIdx) && !isNullOrUndefined(cIdx)) {
                var cell = getCell(rIdx, cIdx, this.parent.getActiveSheet());
                if (!cell || (cell && !cell.comment)) {
                    this.detachCommentIndicator(rIdx, cIdx);
                }
            }
            this.isCommentVisible = false;
            this.activeCommentCell = null;
            if (this.commentListView) {
                this.commentListView.destroy();
                this.commentListView = null;
            }
            this.bodyHost = null;
            this.isEditing = false;
        }
    };
    SpreadsheetComment.prototype.destoryCommentDdb = function (container) {
        [].slice.call(container.querySelectorAll('.e-comment-menu')).forEach(function (commentDdb) {
            destroyComponent(commentDdb, DropDownButton);
        });
        [].slice.call(container.querySelectorAll('.e-reply-ddb')).forEach(function (replyDdb) {
            destroyComponent(replyDdb, DropDownButton);
        });
    };
    SpreadsheetComment.prototype.processSheetComments = function (args) {
        var sheet = args.sheet;
        var id = args.id;
        var comment = args.comment;
        var isDelete = args.isDelete;
        if (!sheet.comments) {
            sheet.comments = [];
        }
        if (isDelete) {
            if (id) {
                var index = sheet.comments.findIndex(function (c) { return c.id === id; });
                if (index !== -1) {
                    sheet.comments.splice(index, 1);
                }
            }
        }
        else {
            if (comment) {
                if (!comment.id) {
                    comment.id = getUniqueID('e_spreadsheet_comment');
                }
                if (comment.replies && comment.replies.length > 0) {
                    comment.replies.forEach(function (reply) {
                        if (!reply.id) {
                            reply.id = getUniqueID('e_spreadsheet_reply');
                        }
                    });
                }
                var existingIdx = sheet.comments.findIndex(function (c) { return c.id === comment.id; });
                if (existingIdx > -1) {
                    sheet.comments[existingIdx] = comment;
                }
                else {
                    var idx = getSortedIndex(sheet.comments, comment.address, true);
                    sheet.comments.splice(idx, 0, comment);
                }
            }
        }
        if (args.isRefresh && !isNullOrUndefined(args.sheetIdx)) {
            this.refreshCommentsPane({ sheetIdx: args.sheetIdx });
        }
    };
    SpreadsheetComment.prototype.updateCommentsFromSheet = function () {
        this.parent.sheets.forEach(function (sheet) {
            if (sheet.comments) {
                sheet.comments.forEach(function (model) {
                    if (!model.isResolved) {
                        model.isResolved = false;
                    }
                    var threadModel = model;
                    threadModel.id = getUniqueID('e_spreadsheet_comment');
                    if (threadModel.replies) {
                        threadModel.replies.forEach(function (reply) {
                            reply.id = getUniqueID('e_spreadsheet_reply');
                        });
                    }
                    var indexes = threadModel.address;
                    setCell(indexes[0], indexes[1], sheet, { comment: threadModel }, true);
                });
            }
        });
    };
    SpreadsheetComment.prototype.showCommentPane = function (args) {
        var host = this.parent.element;
        var id = host.id;
        var sheetPanel = host.querySelector("#" + id + "_sheet_panel");
        var sheetEl = host.querySelector("#" + id + "_sheet");
        var sheetTabPanel = host.querySelector("#" + id + "_sheet_tab_panel");
        if (!sheetPanel || !sheetEl || !sheetTabPanel) {
            return;
        }
        this.parent.setProperties({ showCommentsPane: args.show }, true);
        var reviewPanel = sheetPanel.querySelector("#" + id + "_review_panel");
        if (!args.show) {
            if (this.reviewInstances && this.reviewInstances.length) {
                this.reviewInstances.forEach(function (inst) { return inst.destroy(); });
                this.reviewInstances = [];
            }
            this.reviewHeaderEl = this.reviewBodyEl = null;
            if (this.scheduleMountId) {
                cancelAnimationFrame(this.scheduleMountId);
                this.scheduleMountId = 0;
            }
            if (reviewPanel && reviewPanel.parentElement) {
                reviewPanel.parentElement.removeChild(reviewPanel);
            }
            sheetEl.classList.remove('e-sheet-with-review-panel');
            sheetTabPanel.classList.remove('e-sheet-panel-with-review-panel');
            this.isReviewPaneVisible = false;
        }
        else {
            if (!reviewPanel) {
                reviewPanel = this.parent.createElement('div', { id: id + "_review_panel", className: 'e-review-panel' });
                sheetPanel.appendChild(reviewPanel);
            }
            sheetEl.classList.add('e-sheet-with-review-panel');
            sheetTabPanel.classList.add('e-sheet-panel-with-review-panel');
            reviewPanel.style.height = "calc(100% + " + getDPRValue(sheetTabPanel.getBoundingClientRect().height) + "px)";
            this.isReviewPaneVisible = true;
            this.buildReviewPanelUI(reviewPanel);
        }
        if (this.parent.element.getElementsByClassName('e-addNoteContainer').length) {
            this.parent.notify(updateNoteContainer, null);
        }
    };
    SpreadsheetComment.prototype.buildReviewPanelUI = function (reviewPanel) {
        reviewPanel.innerHTML = '';
        var wrap = this.parent.createElement('div', { className: 'e-review-wrap' });
        this.reviewHeaderEl = this.renderReviewHeader();
        wrap.appendChild(this.reviewHeaderEl);
        reviewPanel.appendChild(wrap);
        this.renderReviewBody();
    };
    SpreadsheetComment.prototype.renderReviewHeader = function () {
        var _this = this;
        var l10n = this.parent.serviceLocator.getService(locale);
        var header = this.parent.createElement('div', { className: 'e-review-header' });
        var wrap1 = this.parent.createElement('div', { className: 'e-review-header-wrap1' });
        var title = this.parent.createElement('div', { className: 'e-review-title' });
        title.textContent = l10n.getConstant('Comments');
        var closeBtnEl = this.parent.createElement('button', {
            className: 'e-review-close',
            attrs: { 'aria-label': 'Close', title: l10n.getConstant('Close') }
        });
        var closeBtn = new Button({ cssClass: 'e-flat', iconCss: 'e-icons e-close' }, closeBtnEl);
        closeBtn.createElement = this.parent.createElement;
        EventHandler.add(closeBtn.element, 'click', function () { return _this.showCommentPane({ show: false }); }, this);
        this.reviewInstances.push(closeBtn);
        wrap1.appendChild(title);
        wrap1.appendChild(closeBtn.element);
        var wrap2 = this.parent.createElement('div', { className: 'e-review-header-wrap2' });
        var newBtnEl = this.parent.createElement('button', {
            className: 'e-review-new',
            attrs: { 'aria-label': 'New', title: l10n.getConstant('New') }
        });
        var newBtn = new Button({
            content: l10n.getConstant('New'), iconCss: 'e-icons e-comment-add',
            enableRtl: this.parent.enableRtl
        }, newBtnEl);
        newBtn.createElement = this.parent.createElement;
        EventHandler.add(newBtn.element, 'click', function () { return _this.renderNewCommentForPanel(); }, this);
        this.reviewInstances.push(newBtn);
        var filterBtn = this.parent.createElement('button', {
            className: 'e-review-filter',
            attrs: { 'aria-label': 'Filter', title: l10n.getConstant('Filter') }
        });
        this.reviewFilterDdb = new DropDownButton({
            iconCss: this.getFilterIconCss(),
            enableRtl: this.parent.enableRtl,
            items: this.getFilterMenuItems(l10n),
            select: function (e) { return _this.onFilterMenuSelect(e); },
            beforeOpen: function () { _this.reviewFilterDdb.setProperties({ items: _this.getFilterMenuItems(l10n) }, true); },
            open: function () { return _this.setPopupPosition(_this.reviewFilterDdb, filterBtn); }
        }, filterBtn);
        this.reviewFilterDdb.createElement = this.parent.createElement;
        this.refreshFilterButton();
        this.reviewInstances.push(this.reviewFilterDdb);
        wrap2.appendChild(newBtn.element);
        wrap2.appendChild(this.reviewFilterDdb.element);
        header.appendChild(wrap1);
        header.appendChild(wrap2);
        return header;
    };
    SpreadsheetComment.prototype.getFilterIconCss = function () {
        return this.reviewFilter === 'all' ? 'e-icons e-filter' : 'e-icons e-filter-active';
    };
    SpreadsheetComment.prototype.getFilterMenuItems = function (l10n) {
        var selectedIcon = 'e-icons e-selected-icon';
        var items = [
            { id: 'all', text: l10n.getConstant('All'), iconCss: this.reviewFilter === 'all' ? selectedIcon : '' },
            { id: 'active', text: l10n.getConstant('Active'), iconCss: this.reviewFilter === 'active' ? selectedIcon : '' },
            { id: 'resolved', text: l10n.getConstant('Resolved'), iconCss: this.reviewFilter === 'resolved' ? selectedIcon : '' }
        ];
        return items;
    };
    SpreadsheetComment.prototype.onFilterMenuSelect = function (event) {
        var l10n = this.parent.serviceLocator.getService(locale);
        var value = '';
        if (event && event.item) {
            if (event.item.id) {
                value = event.item.id;
            }
            else if (event.item.text) {
                value = event.item.text.toLowerCase();
            }
        }
        var validFilters = ['all', 'active', 'resolved'];
        if (validFilters.indexOf(value) !== -1) {
            this.reviewFilter = value;
        }
        if (this.reviewFilterDdb) {
            this.reviewFilterDdb.setProperties({ items: this.getFilterMenuItems(l10n) }, true);
            this.refreshFilterButton();
        }
        this.renderReviewBody();
    };
    SpreadsheetComment.prototype.refreshFilterButton = function () {
        if (this.reviewFilterDdb && this.reviewFilterDdb.element) {
            var iconCss = this.getFilterIconCss();
            this.reviewFilterDdb.iconCss = iconCss;
            this.reviewFilterDdb.dataBind();
        }
    };
    SpreadsheetComment.prototype.filterMatches = function (thread) {
        if (this.reviewFilter === 'active') {
            return thread.isResolved !== true;
        }
        else if (this.reviewFilter === 'resolved') {
            return thread.isResolved === true;
        }
        else {
            return true;
        }
    };
    SpreadsheetComment.prototype.getReviewListHost = function () {
        var element;
        if (this.reviewBodyEl) {
            if (this.reviewBodyEl.classList.contains('e-review-thread-list')) {
                element = this.reviewBodyEl;
            }
            else {
                element = this.reviewBodyEl.querySelector('.e-review-thread-list');
            }
        }
        return element;
    };
    SpreadsheetComment.prototype.getReviewListView = function () {
        var host = this.getReviewListHost();
        return host ? getComponent(host, 'listview') : null;
    };
    SpreadsheetComment.prototype.removeThreadFromPanel = function (threadId) {
        var lv = this.getReviewListView();
        if (lv) {
            lv.removeItem({ id: threadId });
            this.ensureEmptyStateIfNoItems();
            this.scheduleMount();
        }
        else {
            this.showEmptyReviewBody();
        }
    };
    SpreadsheetComment.prototype.insertThreadIntoPanel = function (thread) {
        var _this = this;
        if (this.reviewBodyEl && this.filterMatches(thread)) {
            var lv = this.getReviewListView();
            if (!lv) {
                this.renderReviewBody();
                lv = this.getReviewListView();
                if (!lv) {
                    return;
                }
            }
            var sheet = this.parent.getActiveSheet();
            var allThreads = (sheet && sheet.comments) ? sheet.comments : [];
            var filtered = allThreads.filter(function (t) { return _this.filterMatches(t); });
            var insertIdx = filtered.findIndex(function (t) { return t.id === thread.id; });
            if (insertIdx === -1) {
                return;
            }
            var hostExist = this.reviewBodyEl.querySelector(".e-review-thread-host[data-thread-id=\"" + thread.id + "\"]");
            if (!hostExist) {
                lv.addItem([{ id: thread.id }], undefined, insertIdx);
                this.scheduleMount();
            }
        }
    };
    SpreadsheetComment.prototype.showEmptyReviewBody = function () {
        this.destroyReviewBodyListView();
        if (this.reviewBodyEl) {
            this.reviewBodyEl.innerHTML = '';
            this.renderEmptyReviewBody();
        }
    };
    SpreadsheetComment.prototype.ensureEmptyStateIfNoItems = function () {
        var lv = this.getReviewListView();
        if (lv) {
            var ds = lv.dataSource || [];
            if (!Array.isArray(ds) || ds.length === 0) {
                this.showEmptyReviewBody();
            }
        }
    };
    SpreadsheetComment.prototype.renderReviewBody = function () {
        this.renderReviewBodyForSheetIdx(this.parent.activeSheetIndex);
    };
    SpreadsheetComment.prototype.renderReviewBodyForSheetIdx = function (sheetIdx) {
        var _this = this;
        this.ensureReviewBodyHost();
        if (this.reviewBodyEl) {
            this.destroyReviewBodyListView();
            this.reviewBodyEl.innerHTML = '';
            var sheet = this.parent.sheets[sheetIdx];
            var allThreads = (sheet && sheet.comments) ? sheet.comments : [];
            var threads = allThreads.filter(function (t) {
                if (_this.reviewFilter === 'active') {
                    return t.isResolved !== true;
                }
                else if (_this.reviewFilter === 'resolved') {
                    return t.isResolved === true;
                }
                return true;
            });
            if (threads.length === 0) {
                this.renderEmptyReviewBody();
                return;
            }
            this.renderThreadsList(threads);
        }
    };
    SpreadsheetComment.prototype.ensureReviewBodyHost = function () {
        var reviewPanel = this.parent.element.querySelector("#" + this.parent.element.id + "_review_panel");
        if (reviewPanel) {
            if (!this.reviewBodyEl) {
                this.reviewBodyEl = this.parent.createElement('div', { className: 'e-review-body' });
                var wrap = reviewPanel.querySelector('.e-review-wrap');
                if (wrap) {
                    wrap.appendChild(this.reviewBodyEl);
                }
            }
        }
    };
    SpreadsheetComment.prototype.destroyReviewBodyListView = function () {
        var lv = this.getReviewListView();
        if (lv) {
            this.destoryCommentDdb(lv.element);
            lv.destroy();
        }
    };
    SpreadsheetComment.prototype.renderEmptyReviewBody = function () {
        var l10n = this.parent.serviceLocator.getService(locale);
        var empty = this.parent.createElement('div', { className: 'e-review-empty' });
        empty.textContent = l10n.getConstant(this.reviewFilter !== 'all' ? 'EmptyFilterComment' : 'EmptyComment');
        this.reviewBodyEl.appendChild(empty);
    };
    SpreadsheetComment.prototype.renderThreadsList = function (threads) {
        var _this = this;
        var dataSource = threads.map(function (t) { return ({ id: t.id }); });
        var itemTemplate = function (data) {
            var item = _this.parent.createElement('div', { className: 'e-review-thread', attrs: { id: data.id } });
            var host = _this.parent.createElement('div', { className: 'e-review-thread-host', attrs: { 'data-thread-id': data.id } });
            item.appendChild(host);
            return [item];
        };
        enableRipple(false);
        var listView = new ListView({
            dataSource: dataSource,
            template: itemTemplate,
            cssClass: 'e-review-thread-list',
            enableVirtualization: true,
            height: '100%',
            enableRtl: this.parent.enableRtl,
            select: function (args) { return _this.updateCellSelction(args); },
            actionComplete: function () { return _this.scheduleMount(); },
            scroll: function () { return _this.scheduleMount(); }
        });
        listView.createElement = this.parent.createElement;
        /* eslint-disable */
        listView.isInternalTemplate = true;
        /* eslint-enable */
        listView.appendTo(this.reviewBodyEl);
        this.reviewInstances.push({ destroy: function () { return listView.destroy(); } });
        this.scheduleMount();
    };
    SpreadsheetComment.prototype.scheduleMount = function () {
        var _this = this;
        if (this.scheduleMountId) {
            cancelAnimationFrame(this.scheduleMountId);
        }
        this.scheduleMountId = requestAnimationFrame(function () {
            _this.mountVisibleReviewItems();
            _this.scheduleMountId = 0;
        });
    };
    SpreadsheetComment.prototype.mountVisibleReviewItems = function () {
        var _this = this;
        if (this.reviewBodyEl) {
            var hosts = this.reviewBodyEl.querySelectorAll('.e-review-thread-host');
            hosts.forEach(function (host, index) {
                if (host.getAttribute('data-mounted') !== 'true') {
                    var threadId = host.getAttribute('data-thread-id');
                    if (threadId) {
                        var pos = _this.findThreadPositionById(threadId);
                        if (pos) {
                            var container = _this.buildPaneThreadContainer(pos.row, pos.col, index);
                            host.appendChild(container);
                            host.setAttribute('data-mounted', 'true');
                        }
                    }
                }
            });
        }
    };
    SpreadsheetComment.prototype.buildPaneThreadContainer = function (rIdx, cIdx, index) {
        var container = this.parent.createElement('div', { className: "e-pane-container e-thread-" + index });
        container.tabIndex = -1;
        this.renderCommentUI(container, rIdx, cIdx, true, "e-thread-" + index);
        EventHandler.remove(container, 'mouseout', this.mouseOut);
        var cell = getCell(rIdx, cIdx, this.parent.getActiveSheet());
        var thread = cell && cell.comment;
        if (thread && thread.isResolved) {
            this.handleResolvedThread(container, rIdx, cIdx, thread);
        }
        this.bindContainerEvents(container);
        return container;
    };
    SpreadsheetComment.prototype.findThreadPositionById = function (threadId) {
        var sheet = this.parent && this.parent.getActiveSheet();
        var coll = sheet && sheet.comments || [];
        var thread = coll.find(function (t) { return t.id === threadId; });
        var row;
        var col;
        if (thread && thread.address && Array.isArray(thread.address)) {
            row = thread.address[0];
            col = thread.address[1];
        }
        return { row: row, col: col };
    };
    SpreadsheetComment.prototype.refreshCommentsPane = function (args) {
        if (this.isReviewPaneVisible) {
            var reviewPanel = this.parent.element.querySelector("#" + this.parent.element.id + "_review_panel");
            if (reviewPanel) {
                this.renderReviewBodyForSheetIdx(args.sheetIdx);
            }
        }
    };
    SpreadsheetComment.prototype.renderNewCommentForPanel = function (rIdx, cIdx) {
        var row = rIdx;
        var col = cIdx;
        if (isNullOrUndefined(row) || isNullOrUndefined(col)) {
            var activeAddress = getCellIndexes(this.parent.getActiveSheet().activeCell);
            row = activeAddress[0];
            col = activeAddress[1];
        }
        var sheet = this.parent.getActiveSheet();
        if (!this.reviewBodyEl || (sheet.comments && sheet.comments.length === 0)) {
            this.renderReviewBody();
        }
        var existing = (sheet.comments || []).find(function (t) { return Array.isArray(t.address) && t.address[0] === row && t.address[1] === col; });
        if (existing && existing.id) {
            this.updateThreadSelection(existing.id);
            this.scrollToThreadInPanel(existing.id);
            return;
        }
        var emptyEl = this.reviewBodyEl.querySelector('.e-review-empty');
        if (emptyEl) {
            emptyEl.remove();
        }
        var oldDraft = this.reviewBodyEl.querySelector('.e-pane-container.e-thread-draft');
        if (oldDraft) {
            var host = this.getBodyHost(oldDraft);
            if (host) {
                this.unbindReplyHover(host);
            }
            this.unbindContainerEvents(oldDraft);
            oldDraft.remove();
        }
        var draft = this.parent.createElement('div', { className: 'e-pane-container e-thread-draft' });
        draft.tabIndex = -1;
        var targetElement = this.parent.getCell(row, col);
        if (targetElement && !targetElement.querySelector('.e-comment-indicator')) {
            this.createCommentIndicator({ targetEle: targetElement, rIdx: row, cIdx: col });
        }
        this.renderCommentUI(draft, row, col, true);
        var cell = getCell(row, col, this.parent.getActiveSheet());
        var thread = cell && cell.comment;
        if (thread && thread.isResolved) {
            this.handleResolvedThread(draft, row, col, thread);
        }
        this.bindContainerEvents(draft);
        this.reviewBodyEl.insertBefore(draft, this.reviewBodyEl.firstChild);
        var input = draft.querySelector('.e-comment-footer .e-comment-input');
        if (input) {
            input.focus();
            input.select();
            this.adjustTextareaHeight(input, false);
        }
    };
    SpreadsheetComment.prototype.updateThreadSelection = function (threadId) {
        var _this = this;
        if (!this.reviewBodyEl) {
            this.renderReviewBody();
        }
        if (!this.reviewBodyEl.querySelector(".e-review-thread-host[data-thread-id=\"" + threadId + "\"]")) {
            this.renderReviewBody();
        }
        getUpdateUsingRaf(function () {
            var host = _this.reviewBodyEl.querySelector(".e-review-thread-host[data-thread-id=\"" + threadId + "\"]");
            if (host) {
                var container = host.querySelector('.e-pane-container');
                if (container) {
                    container.focus();
                    host.scrollIntoView({ block: 'nearest' });
                }
            }
        });
    };
    SpreadsheetComment.prototype.updateCellSelction = function (args) {
        if (args && args.item) {
            var host = args.item.querySelector('.e-review-thread-host');
            var container = void 0;
            if (host) {
                container = host.querySelector('.e-pane-container');
            }
            else {
                container = closest(args.item, '.e-pane-container');
            }
            if (container) {
                var idx = this.getIndexesFromContainer(container);
                if (idx && idx.length === 2) {
                    this.parent.goTo(getSheetName(this.parent, this.parent.activeSheetIndex) + '!' + getCellAddress(idx[0], idx[1]));
                }
            }
        }
    };
    SpreadsheetComment.prototype.refreshReviewListFromSheet = function () {
        var _this = this;
        if (!this.isReviewPaneVisible || !this.reviewBodyEl) {
            return;
        }
        var sheet = this.parent.getActiveSheet();
        var allThreads = sheet.comments || [];
        var filtered = allThreads.filter(function (t) { return _this.filterMatches(t); });
        var dataSource = filtered.map(function (t) { return ({ id: t.id }); });
        if (dataSource.length === 0) {
            this.showEmptyReviewBody();
            return;
        }
        var listView = this.getReviewListView();
        if (listView) {
            listView.setProperties({ dataSource: dataSource }, true);
            listView.refresh();
            this.scheduleMount();
        }
        else {
            this.renderReviewBody();
        }
    };
    SpreadsheetComment.prototype.syncThreadInPanel = function (thread) {
        if (!this.isReviewPaneVisible || !this.reviewBodyEl || !thread || !thread.id) {
            return;
        }
        if (this.reviewFilter !== 'all') {
            var shouldShow = this.filterMatches(thread);
            var hostExist = this.reviewBodyEl.querySelector(".e-review-thread-host[data-thread-id=\"" + thread.id + "\"]");
            if (shouldShow && !hostExist) {
                this.insertThreadIntoPanel(thread);
            }
            else if (!shouldShow && hostExist) {
                this.removeThreadFromPanel(thread.id);
            }
        }
        var host = this.reviewBodyEl.querySelector(".e-review-thread-host[data-thread-id=\"" + thread.id + "\"]");
        if (host) {
            var container = host.querySelector('.e-pane-container');
            if (!container) {
                this.refreshReviewListFromSheet();
                return;
            }
            var rIdx = thread.address[0];
            var cIdx = thread.address[1];
            if (typeof rIdx === 'number' && typeof cIdx === 'number') {
                this.renderThreadContainer(rIdx, cIdx, thread, container);
            }
            var body = container.querySelector('.e-comment-body');
            if (body) {
                var lv = getComponent(body, 'listview');
                if (lv) {
                    var data = thread ? this.convertThreadToListItems(thread) : [];
                    lv.setProperties({ dataSource: data }, true);
                    lv.refresh();
                }
                else {
                    var newBody = this.createBodyContent(thread, true, true);
                    var footer = container.querySelector('.e-comment-footer');
                    if (newBody && footer) {
                        container.insertBefore(newBody, footer);
                    }
                }
            }
        }
        else {
            this.refreshReviewListFromSheet();
        }
    };
    SpreadsheetComment.prototype.getFilteredThreadsForActiveSheet = function () {
        var sheet = this.parent.getActiveSheet();
        var all = sheet.comments || [];
        var result = [];
        for (var i = 0; i < all.length; i++) {
            var t = all[i];
            if (this.filterMatches(t)) {
                result.push(t);
            }
        }
        return result;
    };
    SpreadsheetComment.prototype.getThreadIndexInFiltered = function (threadId) {
        var list = this.getFilteredThreadsForActiveSheet();
        for (var i = 0; i < list.length; i++) {
            if (list[i].id === threadId) {
                return i;
            }
        }
        return -1;
    };
    SpreadsheetComment.prototype.scrollToThreadInPanel = function (threadId, isSelection) {
        var _this = this;
        if (!this.isReviewPaneVisible || !this.reviewBodyEl || !threadId) {
            return;
        }
        var lv = this.getReviewListView();
        if (!lv) {
            return;
        }
        var filteredIndex = this.getThreadIndexInFiltered(threadId);
        if (filteredIndex < 0) {
            return;
        }
        lv.selectItem({ id: threadId });
        this.scheduleMount();
        getUpdateUsingRaf(function () {
            _this.mountVisibleReviewItems();
            var selector = '.e-review-thread-host[data-thread-id="' + threadId + '"]';
            var host = _this.reviewBodyEl.querySelector(selector);
            if (host) {
                host.scrollIntoView({ block: 'nearest' });
                var container = host.querySelector('.e-pane-container');
                if (container) {
                    container.focus();
                    var input = container.querySelector('.e-comment-footer .e-comment-input');
                    if (input && !isSelection) {
                        input.focus();
                        input.select();
                    }
                }
            }
        });
    };
    SpreadsheetComment.prototype.onCommentUndoRedo = function (args) {
        if (args && args.cellIdx && !isNullOrUndefined(args.sheetIdx)) {
            var sheet = this.parent.sheets[args.sheetIdx];
            var row_1 = args.cellIdx[0];
            var col_1 = args.cellIdx[1];
            var cell = getCell(row_1, col_1, sheet);
            var model = cell && cell.comment;
            var existing_1 = sheet.comments.find(function (t) { return t.address && t.address[0] === row_1 && t.address[1] === col_1; });
            if (model) {
                if (!Array.isArray(model.address)) {
                    model.address = [row_1, col_1];
                }
                if (existing_1) {
                    var idxInColl = sheet.comments.findIndex(function (c) { return c.id === existing_1.id; });
                    if (idxInColl > -1) {
                        if (model.id !== existing_1.id) {
                            model.id = existing_1.id;
                        }
                        sheet.comments[idxInColl] = model;
                    }
                }
                else {
                    this.processSheetComments({ sheet: sheet, comment: model, isDelete: false });
                }
                if (this.parent.activeSheetIndex === args.sheetIdx) {
                    var td = this.parent.getCell(row_1, col_1);
                    if (td && !td.querySelector('.e-comment-indicator')) {
                        this.createCommentIndicator({ targetEle: td, rIdx: row_1, cIdx: col_1 });
                    }
                    var cont = this.getCommentContainer();
                    if (cont) {
                        var indices = this.getIndexesFromContainer(cont);
                        if (indices && indices[0] === row_1 && indices[1] === col_1) {
                            this.renderThreadContainer(row_1, col_1, model, cont);
                            var body = cont.querySelector('.e-comment-body');
                            if (body) {
                                var lv = getComponent(body, 'listview');
                                if (lv) {
                                    lv.setProperties({ dataSource: this.convertThreadToListItems(model) }, true);
                                    lv.refresh();
                                }
                            }
                        }
                    }
                }
            }
            else {
                if (existing_1) {
                    this.processSheetComments({ sheet: sheet, id: existing_1.id, isDelete: true });
                }
                this.detachCommentIndicator(row_1, col_1);
                var cont = this.getCommentContainer();
                if (cont) {
                    var indices = this.getIndexesFromContainer(cont);
                    if (indices && indices[0] === row_1 && indices[1] === col_1) {
                        this.removeCommentContainer();
                    }
                }
            }
            if (this.isReviewPaneVisible) {
                this.refreshCommentsPane({ sheetIdx: args.sheetIdx });
            }
        }
    };
    SpreadsheetComment.prototype.navigateNextPrevComment = function (args) {
        var _this = this;
        var startSheetIdx = this.parent.activeSheetIndex;
        var activeSheet = this.parent.getActiveSheet();
        var address = getCellIndexes(activeSheet.activeCell);
        var currentColl = activeSheet.comments ? activeSheet.comments : [];
        var navigate = function (sheetIdx, address) {
            _this.parent.goTo(getSheetName(_this.parent, sheetIdx) + "!" + getRangeAddress(address));
        };
        var crossSheetNavigate = function (startIdx) {
            var sheetCount = _this.parent.sheets.length;
            for (var step = 1; step < sheetCount; step++) {
                var index = (startIdx + (args.isNext ? step : -step) + sheetCount) % sheetCount;
                var edge = _this.getEdgeThreadFromSheet(_this.parent.sheets[index], !args.isNext);
                if (edge && edge.address) {
                    navigate(index, edge.address);
                    return true;
                }
            }
            return false;
        };
        if (currentColl.length > 0) { // Try within the current sheet first
            var pos = getSortedIndex(currentColl, address, true);
            var exactIdx = -1;
            if (pos < currentColl.length) {
                var comment_1 = currentColl[pos];
                if (comment_1 && comment_1.address && comment_1.address[0] === address[0] && comment_1.address[1] === address[1]) {
                    exactIdx = pos;
                }
            }
            if (exactIdx === -1 && pos > 0) {
                var prevComment = currentColl[(pos - 1)];
                if (prevComment && prevComment.address && prevComment.address[0] === address[0] && prevComment.address[1] === address[1]) {
                    exactIdx = pos - 1;
                }
            }
            var idx = args.isNext ? (exactIdx > -1 ? exactIdx + 1 : pos) : (exactIdx > -1 ? exactIdx - 1 : pos - 1);
            if (idx < 0 || idx >= currentColl.length) { // If out of bounds within current sheet, try cross-sheet.
                var navigated = crossSheetNavigate(startSheetIdx);
                if (navigated) {
                    return;
                }
                idx = args.isNext ? 0 : currentColl.length - 1;
            }
            var comment = currentColl[idx];
            if (comment && comment.address) { // Next/Prev within the same sheet
                navigate(startSheetIdx, comment.address);
                return;
            }
        }
        // Cross-sheet fallback: move forward/backward to the next sheet that has comments
        crossSheetNavigate(startSheetIdx);
    };
    SpreadsheetComment.prototype.getEdgeThreadFromSheet = function (sheet, fromEnd) {
        var coll = sheet.comments ? sheet.comments : [];
        if (coll.length === 0) {
            return undefined;
        }
        return fromEnd ? coll[coll.length - 1] : coll[0]; // Next => take first comment; Prev => take last comment
    };
    /**
     * Destroy SpreadsheetComment Module.
     *
     * @returns {void} - Destroy SpreadsheetComment module.
     */
    SpreadsheetComment.prototype.destroy = function () {
        this.removeEventListener();
        if (this.scheduleMountId) {
            cancelAnimationFrame(this.scheduleMountId);
            this.scheduleMountId = 0;
        }
        if (this.activeReplyDdb) {
            this.activeReplyDdb.destroy();
        }
        this.activeReplyDdb = null;
        if (this.reviewFilterDdb) {
            this.reviewFilterDdb.destroy();
        }
        this.reviewFilterDdb = null;
        if (this.reviewInstances && this.reviewInstances.length) {
            this.reviewInstances.forEach(function (inst) { inst.destroy(); });
        }
        this.reviewInstances = [];
        if (this.commentListView) {
            this.commentListView.destroy();
        }
        this.commentListView = null;
        if (this.reviewPaneEl && this.reviewPaneEl.parentElement) {
            this.reviewPaneEl.parentElement.removeChild(this.reviewPaneEl);
        }
        this.reviewPaneEl = null;
        this.reviewFilter = null;
        this.reviewHeaderEl = null;
        this.reviewBodyEl = null;
        this.isReviewPaneVisible = null;
        if (!this.parent.isDestroyed && !this.parent.refreshing) {
            var commentIndicators = this.parent.element.getElementsByClassName('e-comment-indicator');
            while (commentIndicators.length) {
                var indicator = commentIndicators[0];
                if (indicator) {
                    EventHandler.remove(indicator, 'mouseover', this.mouseOver);
                    EventHandler.remove(indicator, 'mouseout', this.mouseOut);
                    delete indicator.dataset.commentListenersAdded;
                    delete indicator.dataset.commentRowIndex;
                    delete indicator.dataset.commentColIndex;
                    detach(indicator);
                }
            }
            this.removeCommentContainer();
        }
        this.isCommentVisible = null;
        this.activeCommentCell = null;
        this.isEditing = null;
        this.editingState = null;
        this.bodyHost = null;
        this.parent = null;
    };
    /**
     * Get the SpreadsheetComment Module Name.
     *
     * @returns {string} - Get the spreadsheetComment module name.
     */
    SpreadsheetComment.prototype.getModuleName = function () {
        return 'spreadsheetComment';
    };
    return SpreadsheetComment;
}());
export { SpreadsheetComment };
